import { noop } from "../../../common/function";
import { PREFIX } from "..";
import { dispatchTrackingEvent, lifecycleEvents, synteticEvents } from "../event/event";
import { loggerScope } from "../parser/utils";
import type { Unset } from "../../event/index.js";
import { o_util } from "../../../common/namespaces.js";

/*                     */
const { on } = o_util.event

const EVENT_NAME = synteticEvents[2];
const log = loggerScope.scope(EVENT_NAME);

export function callback(this: HTMLElement): void {
  if (!dispatchTrackingEvent(this, EVENT_NAME, { [PREFIX]: { method: "submitMove" } }))
    log.debug(EVENT_NAME, "has been terminated by lifecycle hook for", this);
}

const register = (elementToTrack: HTMLElement): Unset => {
  if (
    !dispatchTrackingEvent(elementToTrack, lifecycleEvents[1], { event: EVENT_NAME, options: {} })
  ) {
    log.debug(EVENT_NAME, "register terminated by lifecycle hook for", this);
    return noop;
  }

  return on(elementToTrack, "click", callback);
};

const synteticLinkMove = [EVENT_NAME, register] as const;
export default synteticLinkMove;
